import type { ReactNode } from 'react';

export const symbol_splitscreen: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-533q-24 0-42-18t-18-42v-187q0-24 18-42t42-18h600q24 0 42 18t18 42v187q0 24-18 42t-42 18H180Zm0-60h600v-187H180v187Zm0 473q-24 0-42-18t-18-42v-188q0-24 18-42t42-18h600q24 0 42 18t18 42v188q0 24-18 42t-42 18H180Zm0-60h600v-188H180v188Zm0-413v-187 187Zm0 413v-188 188Z"
		/>
	</svg>
);
